import {injectable} from "tsyringe";
import {transformer} from "../decorators/transformer.decorator";
import {TransformerInterface} from "./transformerInterface";
import {CommandDTO} from "../domain/dtos/command.dto";
import {CreateLinkviewCommand, CreateLinkviewPayload} from "../commands/create-linkview.command";

/**
 * Serialises a CreateLinkviewCommand into the backend command DTO.
 *
 * A dedicated transformer is REQUIRED, not a nicety. Without one the generic
 * command→DTO fallback runs, and that fallback demands a change-tracked proxy
 * as the payload — these commands carry a plain object, so it throws
 * "The payload of the command must be a proxified object". The throw happens
 * OUTSIDE the CommandBus's try block, which wedges the bus for the rest of the
 * session rather than failing the one command.
 *
 * The full envelope is emitted, not just the payload: inside a bulk each
 * sub-command is re-built through the command factory on the server, so every
 * element needs `name`, `uid`, `mainEntityClass` and `mainEntityUid` exactly
 * like an outer command.
 *
 * The payload is `{uid, title, icon}`; `icon` (a `LINKVIEW_ICON_KEYS` key) goes
 * out untouched under the key `icon`, which is the name the backend reads.
 */
@injectable()
@transformer({
    source: CreateLinkviewCommand,
    target: `dto`
})
export class CreateLinkviewCommandToDtoTransformer implements TransformerInterface<CommandDTO<CreateLinkviewPayload>, CreateLinkviewCommand> {

    public async transform(command: CreateLinkviewCommand): Promise<CommandDTO<CreateLinkviewPayload>> {
        return <CommandDTO<CreateLinkviewPayload>>{
            uid: command.uid,
            name: command.name,
            mainEntityClass: command.mainEntityClass,
            mainEntityUid: command.mainEntityUid,
            payload: command.payload,
        };
    }
}
